import BannerMainImg from '../../../assets/image/banner/banner-main.png'
import BannerSecondImg from "../../../assets/image/banner/banner-second.png"
import BannerThirdImg from "../../../assets/image/banner/banner-third.png"

export const imagesSrc = [
  {
    id:1,
    name: "banner-main",
    src: BannerMainImg,
  },
  {
    id:2,
    name: "banner-second",
    src: BannerSecondImg,
  },
  {
    id:3,
    name: "banner-third",
    src: BannerThirdImg,
  },
]